import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions 
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSwimming } from '../context/SwimmingContext';
import { useTheme } from '../theme/ThemeContext';

function Navigation() {
  const navigate = useNavigate();
  const { isCompetitionEnded, resetCompetition } = useSwimming();
  const { isDarkMode } = useTheme();
  const [confirmNewCompetition, setConfirmNewCompetition] = useState(false);

  const handleNewCompetitionClick = () => {
    setConfirmNewCompetition(true);
  };

  const handleConfirmNewCompetition = () => {
    resetCompetition();
    setConfirmNewCompetition(false);
    navigate('/');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <AppBar position="static" sx={{ 
        background: isDarkMode 
          ? 'linear-gradient(90deg, #004c5c 0%, #0a1929 100%)'
          : 'linear-gradient(90deg, #00b4d8 0%, #184183 100%)',
        transition: 'background 0.3s ease'
      }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Button 
              color="inherit" 
              onClick={() => handleNavigation('/')}
              sx={{ '&:hover': { opacity: 0.8 } }}
            >
              Início
            </Button>
            <Button 
              color="inherit" 
              onClick={() => handleNavigation('/competition')}
              sx={{ '&:hover': { opacity: 0.8 } }}
            >
              Competição
            </Button>
            <Button 
              color="inherit" 
              onClick={() => handleNavigation('/results')}
              sx={{ '&:hover': { opacity: 0.8 } }}
            >
              Resultados
            </Button>
          </Box>
          {isCompetitionEnded && (
            <Button 
              color="inherit"
              onClick={handleNewCompetitionClick}
              variant="contained"
              sx={{ 
                bgcolor: isDarkMode ? 'secondary.dark' : 'secondary.main', 
                '&:hover': { 
                  bgcolor: isDarkMode ? 'secondary.main' : 'secondary.dark',
                  opacity: 0.9
                }
              }}
            >
              Nova Competição
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Dialog
        open={confirmNewCompetition}
        onClose={() => setConfirmNewCompetition(false)}
      >
        <DialogTitle>Confirmar Nova Competição</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja iniciar uma nova competição? Todos os dados da competição atual serão apagados.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmNewCompetition(false)}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmNewCompetition} color="primary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Navigation;